import { lazy } from 'react';
import { useSelector } from '@client/hooks/redux.hooks';
import { Loader } from '@client/components/common/Loader';
import { hasFooterSelector } from './selectors';

const FooterLoader = lazy(() => import(/* webpackPrefetch: true */ './FooterComponent'));

export const Footer = () => {
  const hasFooter = useSelector(hasFooterSelector);

  if (!hasFooter) {
    return null;
  }

  return (
    <Loader load={FooterLoader} />
  );
};
